export const tableBackgroundColor = (i: number) => {
	return i % 2 === 0 ? 'bg-gray-50' : 'bg-gray-100';
};
